export default __webpack_public_path__ + "static/media/choose_4.3f6d0ac7.png";